"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWashingMachine = function IconWashingMachine(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.77 7A2.77 2.77 0 0 0 9 9.77v2.2h9V7zM39 9.77v2.2H19V7h17.23A2.77 2.77 0 0 1 39 9.77m-30 4.2v24.26A2.77 2.77 0 0 0 11.77 41h24.46A2.77 2.77 0 0 0 39 38.23V13.97zm-.603-7.573A4.77 4.77 0 0 1 11.77 5h24.46A4.77 4.77 0 0 1 41 9.77v28.46A4.77 4.77 0 0 1 36.23 43H11.77A4.77 4.77 0 0 1 7 38.23V9.77a4.77 4.77 0 0 1 1.397-3.373m7.49 17.4a8.55 8.55 0 1 0 16.044-.498 7.67 7.67 0 0 1-7.854 1.166 36 36 0 0 1-1.14-.447c-.977-.396-1.903-.772-2.97-.922-1.15-.16-2.457-.048-4.08.7m.558-1.303c1.364-.472 2.56-.542 3.66-.388 1.2.168 2.295.613 3.308 1.024.349.142.689.28 1.019.4l.011.005.01.004a6.67 6.67 0 0 0 7.032-1.175A8.55 8.55 0 0 0 24 17.95a8.55 8.55 0 0 0-7.555 4.544M13.55 26.5c0-5.771 4.679-10.45 10.45-10.45s10.45 4.679 10.45 10.45S29.771 36.95 24 36.95 13.55 32.271 13.55 26.5M24.5 9a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 20a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-3.85 2.97a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M32 10h5V9h-5zM20 26a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11-17h2V9h-2z",
    clipRule: "evenodd"
  })));
};

export { IconWashingMachine, IconWashingMachine as default };
